import { useState, Fragment } from 'react'
import clsx from 'clsx'
import { formatCurrency } from '../../../../../../utils/formatter'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import SearchIcon from '@mui/icons-material/Search'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Text } from '../../../../../ui'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import PendingIcon from '@mui/icons-material/HourglassEmpty'
import ReplayIcon from '@mui/icons-material/Replay'
import mercadoPagoLogo from '../../../../../../../assets/iconosBancos/mercadoPago.jpg'
import getnetLogo from '../../../../../../../assets/transactions/getnet/getnet-logo.png'
import transbankLogo from '../../../../../../../assets/iconosBancos/transbank-logo.png'
import RowToggle from '../../common/RowToggle'
import Lottie from 'lottie-react'
import LoaderAdm from '../../../../../../../assets/svgIcons/LoaderAdm.json'
import { GETNET, MERCADOPAGO, TRANSBANK } from '../../../../../../utils/constant'

export const OPERATION_TYPE_LABELS = {
  pos_payment: 'POS',
  regular_payment: 'Pago Digital',
  recurring_payment: 'Pago Suscripción',
  card_validation: 'Validación',
  account_fund: 'Fondo',
  partition_transfer: 'Transferencia',
  money_transfer: 'Transferencia de dinero',
  payment_addition: 'Adición de pago'
}

const COLUMN_SETS = {
  '': [
    { col: 'Proveedor',            field: 'source',      width: 'w-[7%]' },
    { col: 'Fecha',                field: 'fecha',       width: 'w-[8%]' },
    { col: 'Descripción',          field: 'descripcion', width: 'w-[16%]' },
    { col: 'POS ID',               field: 'pos_id',      width: 'w-[9%]' },
    { col: 'Local',                field: 'local',       width: 'w-[9%]' },
    { col: 'Monto Total',          field: 'monto',       width: 'w-[9%]' },
    { col: 'Transacción Recibida', field: 'recibido',    width: 'w-[9%]' },
    { col: 'Comisión',             field: 'comision',    width: 'w-[9%]' },
    { col: 'Propina',              field: 'propina',     width: 'w-[7%]' },
    { col: 'Estado',               field: 'status',      width: 'w-[15%]' },
  ],
  regular_payment: [
    { col: 'Proveedor',            field: 'source',      width: 'w-[7%]' },
    { col: 'Fecha',                field: 'fecha',       width: 'w-[8%]' },
    { col: 'Descripción',          field: 'descripcion', width: 'w-[20%]' },
    { col: 'Nombre',               field: 'nombre',      width: 'w-[15%]' },
    { col: 'Monto Total',          field: 'monto',       width: 'w-[9%]' },
    { col: 'Transacción Recibida', field: 'recibido',    width: 'w-[9%]' },
    { col: 'Comisión',             field: 'comision',    width: 'w-[9%]' },
    { col: 'Estado',               field: 'status',      width: 'w-[10%]' },
  ],
  recurring_payment: [
    { col: 'Proveedor',              field: 'source',               width: 'w-[7%]' },
    { col: 'Fecha',                  field: 'fecha',                width: 'w-[8%]' },
    { col: 'Descripción',            field: 'descripcion',          width: 'w-[14%]' },
    { col: 'Tipo de pago recurrente',field: 'tipo_pago_recurrente', width: 'w-[11%]' },
    { col: 'Nº Cuota',               field: 'num_cuota',            width: 'w-[6%]' },
    { col: 'Nombre',                 field: 'nombre',               width: 'w-[13%]' },
    { col: 'Monto Total',            field: 'monto',                width: 'w-[9%]' },
    { col: 'Transacción Recibida',   field: 'recibido',             width: 'w-[9%]' },
    { col: 'Comisión',               field: 'comision',             width: 'w-[9%]' },
    { col: 'Estado',                 field: 'status',               width: 'w-[10%]' },
  ],
  card_validation: [
    { col: 'Proveedor',            field: 'source',      width: 'w-[7%]' },
    { col: 'Fecha',                field: 'fecha',       width: 'w-[8%]' },
    { col: 'Descripción',          field: 'descripcion', width: 'w-[16%]' },
    { col: 'Tarjeta',              field: 'tarjeta',     width: 'w-[12%]' },
    { col: 'Email',                field: 'email',       width: 'w-[16%]' },
    { col: 'Monto Total',          field: 'monto',       width: 'w-[9%]' },
    { col: 'Transacción Recibida', field: 'recibido',    width: 'w-[9%]' },
    { col: 'Comisión',             field: 'comision',    width: 'w-[9%]' },
    { col: 'Estado',               field: 'status',      width: 'w-[10%]' },
  ],
}
COLUMN_SETS.pos_payment = COLUMN_SETS['']

const formatOperationTypeDisplay = text => {
  if (!text) return ''
  const lower = String(text).trim().toLowerCase()
  return lower.charAt(0).toUpperCase() + lower.slice(1)
}

export const getOperationTypeLabel = operationType => {
  if (!operationType) return ''
  const base =
    OPERATION_TYPE_LABELS[operationType] || operationType.replace(/_/g, ' ')
  return formatOperationTypeDisplay(base)
}

const ProviderBadge = ({ source }) => {
  const providerConfig = {
    mercadopago_pos: { logo: mercadoPagoLogo, alt: 'Mercado Pago' },
    getnet_abonos: { logo: getnetLogo, alt: 'Getnet' },
    getnet_ventas: { logo: getnetLogo, alt: 'Getnet' },
    getnet_completo: { logo: getnetLogo, alt: 'Getnet' },
    transbank_cartola: { logo: transbankLogo, alt: 'Transbank' }
  }

  const config = providerConfig[source] || { text: source || 'N/A', bg: 'bg-gray-100', color: 'text-gray-700', border: 'border-gray-300' }

  if (config.logo) {
    return (
      <div className="flex items-center justify-center">
        <img
          src={config.logo}
          alt={config.alt}
          className={clsx("h-4 w-auto rounded", config.alt?.toLowerCase().includes('mercado') && "-ml-1")}
        />
      </div>
    )
  }

  return (
    <div className={`flex items-center justify-center px-2 py-1 rounded ${config.bg} ${config.color} ${config.border} border`}>
      <span className="text-xs font-semibold">{config.text}</span>
    </div>
  )
}

const TableTransactions = ({
  rows,
  groupedRows,
  order,
  onSort,
  loading,
  activeTab,
  summaryData = [],
  expandedDays = {},
  onToggleDay = () => { },
  fetchedDetails = {},
  loadingDetails = {},
  mpOperationType = ''
}) => {

  const [expandedDetailRows, setExpandedDetailRows] = useState(new Set())
  const [expandedTransactions, setExpandedTransactions] = useState(new Set())
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const toggleTransaction = (id) => {
    setExpandedTransactions(prev => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })
  }

  const toggleDay = (date) => {
    setExpandedDetailRows(prev => {
      const next = new Set(prev)
      if (next.has(date)) {
        next.delete(date)
      } else {
        next.add(date)
      }
      return next
    })
  }

  const styles = {
    table: 'w-full min-w-[980px] table-fixed text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-0 z-20 bg-white shadow-[0_1px_0_0_#e5e7eb,0_2px_6px_-2px_rgba(0,0,0,0.1)]',
    th: 'sticky top-0 z-20 py-2 px-1 sm:px-2 text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500 bg-white',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-1 sm:px-2 text-center break-words align-middle',
    smallCol: 'w-auto max-w-[70px] sm:max-w-[80px]',
    wideCol: '',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem] text-gray-900',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-900 font-bold',
    dateHeader: 'bg-gray-50/80 backdrop-blur-sm border-y border-gray-200/50 py-2 px-4 text-left font-bold text-primary flex items-center gap-2 cursor-pointer hover:bg-gray-100 transition-colors group font-sans'
  }

  const activeCols =
    activeTab === MERCADOPAGO && COLUMN_SETS[mpOperationType]
      ? COLUMN_SETS[mpOperationType]
      : COLUMN_SETS['']

  const isGetnet = (source) => {
    return source === 'getnet_ventas' || source === 'getnet_abonos' || source === 'getnet_completo' || source?.includes('getnet');
  }

  const isTransbank = (source) => {
    return source === 'transbank_cartola' || source?.includes('transbank');
  }

  const normalizeStatus = status => String(status || '').toLowerCase().trim()

  const isLiberadoStatus = (status) => {
    const normalized = normalizeStatus(status)
    if (!normalized) return false
    if (normalized.includes('no liberado')) return false
    if (normalized.includes('liberado')) return true
    return ['approved', 'success', 'paid', 'pagado', 'abonado', 'settled'].includes(normalized)
  }

  const getStatusInfo = (row) => {
    if (isGetnet(row.source)) {
      const payloadEstado = normalizeStatus(row.rawData?.payload?.estado)
      const isLiberado = payloadEstado === 'abonado'
      return {
        isLiberado,
        isRefunded: false,
        label: isLiberado ? 'LIBERADO' : 'NO LIBERADO',
        icon: isLiberado ? <CheckCircleIcon style={{ fontSize: 14 }} /> : <PendingIcon style={{ fontSize: 14 }} />
      }
    }

    const status = normalizeStatus(row.status || row.estado)
    const isRefunded = status === 'refunded'
    const isLiberado = !isRefunded && isLiberadoStatus(status)
    return {
      isLiberado,
      isRefunded,
      label: isRefunded ? 'REEMBOLSADO' : isLiberado ? 'LIBERADO' : 'NO LIBERADO',
      icon: isRefunded
        ? <ReplayIcon style={{ fontSize: 14 }} />
        : isLiberado
          ? <CheckCircleIcon style={{ fontSize: 14 }} />
          : <PendingIcon style={{ fontSize: 14 }} />
    }
  }

  const statusBadgeClass = (isLiberado, isRefunded = false) =>
    clsx(
      'inline-flex items-center justify-center gap-1.5 rounded-full px-3 py-1 text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider leading-tight',
      isRefunded ? 'text-warning bg-warning/10' : isLiberado ? 'text-success bg-success/10' : 'text-danger bg-danger/10'
    )

  const hasRows = Array.isArray(rows) && rows.length > 0

  if (loading) return null

  if (!hasRows) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <SearchIcon fontSize="large" className="mb-4 text-gray-400" />
        <Text>No hay transacciones para el período seleccionado</Text>
      </div>
    )
  }

  const getRowValues = (row) => {
    let monto, recibido, comision, propina;

    if (isGetnet(row.source)) {
      monto = Number(row.rawData?.payload?.valor_venta || 0);
      recibido = Number(row.rawData?.payload?.monto_abono || 0);
      comision = Number(row.rawData?.payload?.comision || 0);
      propina = Number(row.rawData?.payload?.propina || 0);
    } else if (isTransbank(row.source)) {
      monto = Number(row.monto || row.abono || row.rawData?.payload?.monto_afecto || 0);
      recibido = Number(row.abono || row.rawData?.payload?.abono || 0);
      comision = 0;
      propina = 0;
    } else {
      monto = Number(row.monto || 0);
      recibido = Number(row.rawData?.payload?.transaction_details?.net_received_amount || 0);
      comision = Number(row.rawData?.payload?.fee_details?.[0]?.amount || 0);
      propina = Number(row.rawData?.payload?.metadata?.tip_amount || 0);
    }

    return { monto, comision, propina, recibido };
  }

  const getAmountBlock = (label, value, alignRight = false) => (
    <div className={clsx(alignRight && 'text-right')}>
      <Text className='text-[10px] text-gray-400'>{label}</Text>
      <Text className='text-sm font-bold'>{formatCurrency(value || 0)}</Text>
    </div>
  )

  const getPosId = (row) => {
    if (isGetnet(row.source)) {
      return row.rawData?.payload?.terminal || '-';
    }
    if (isTransbank(row.source)) {
      return row.rawData?.payload?.codigo_comercio || '-';
    }
    return row.rawData?.payload?.pos_id || '-';
  }

  const getLocal = (row) => {
    if (isGetnet(row.source)) {
      return row.rawData?.payload?.local || '-';
    }
    if (isTransbank(row.source)) {
      return row.rawData?.payload?.nombre_local || row.nombreLocal || '-';
    }
    return row.rawData?.payload?.additional_info?.point_location?.city || '-';
  }

  const getDescripcion = (row) => {
    if (isGetnet(row.source)) {
      return row.descripcion || row.rawData?.payload?.tipo_mov || '-';
    }
    if (isTransbank(row.source)) {
      return row.descripcion || row.rawData?.payload?.tipo_de_movimiento || '-';
    }
    return row.rawData?.payload?.description || row.rawData?.payload?.external_reference || '-';
  }

  const getCard = (row) => {
    const digits = row.rawData?.payload?.card?.last_four_digits
    return digits ? `•••• ${digits}` : '-'
  }

  const getEmail = (row) => row.rawData?.payload?.payer?.email || '-'

  const getRefExterna = (row) => row.rawData?.payload?.external_reference || '-'

  const getPreapprovalId = (row) => row.rawData?.payload?.metadata?.preapproval_id || '-'

  const getCardholderName = (row) => {
    const name = row.rawData?.payload?.card?.cardholder?.name
    if (!name) return '-'
    return name.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())
  }

  const getTipoPagoRecurrente = (row) => {
    const type = row.rawData?.payload?.point_of_interaction?.type
    if (!type) return '-'
    return type === 'SUBSCRIPTIONS' ? 'Suscripción' : type.replace(/_/g, ' ')
  }

  const getNumCuota = (row) => {
    const num = row.rawData?.payload?.point_of_interaction?.transaction_data?.subscription_sequence?.number
    return num != null ? String(num) : '-'
  }

  const formatFechaAgrupada = (fecha) => {
    if (typeof fecha === 'string') {
      const parts = fecha.split('-');
      if (parts.length === 3 && parts[0].length === 4) {
        const [year, month, day] = parts;
        return `${day}-${month}-${year}`;
      }
    }
    return fecha;
  }

  const formatFecha = (fecha) => {
    if (!fecha) {
      return fecha
    }

    const date = new Date(fecha)

    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}-${month}-${year}`
    }

    if (typeof fecha === 'string') {
      const cleaned = fecha.split('T')[0].split(' ')[0].slice(0, 10)
      const parts = cleaned.split('-')
      if (parts.length === 3 && parts[0].length === 4) {
        const [year, month, day] = parts
        return `${day}-${month}-${year}`
      }
    }

    return fecha
  }

  const renderSummaryCard = (daySummary) => {
    const isExpanded = expandedDays[daySummary.fecha]
    return (
      <div className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
        <div className='flex items-start justify-between gap-2'>
          <div className='flex items-start gap-2'>
            <ProviderBadge source={daySummary.source} />
            <div>
              <Text className='text-xs font-bold'>
                {formatFechaAgrupada(daySummary.fecha)}
              </Text>
              <Text className='text-[11px] text-gray-500'>
                {daySummary.cantidadTransacciones || 0} transacciones
              </Text>
            </div>
          </div>
          <button
            type='button'
            className='flex items-center justify-center w-8 h-8 rounded-full bg-gray-100'
            onClick={() => onToggleDay(daySummary.fecha)}
            aria-label={isExpanded ? 'Ocultar detalle' : 'Ver detalle'}
          >
            <KeyboardArrowDownIcon
              className={clsx('transition-transform', { 'rotate-180': isExpanded })}
            />
          </button>
        </div>
        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          {getAmountBlock('Monto total', daySummary.montoTotal)}
          {getAmountBlock('Transacción recibida', daySummary.recibidoTotal, true)}
          {getAmountBlock('Comisión', daySummary.comisionTotal)}
          {getAmountBlock('Propina', daySummary.propinaTotal, true)}
        </div>
      </div>
    )
  }

  const renderDayGroupCard = (date, dayTransactions) => {
    const isExpanded = expandedDetailRows.has(date)
    const dayTotals = dayTransactions.reduce((acc, row) => {
      const vals = getRowValues(row)
      return {
        monto: acc.monto + vals.monto,
        recibido: acc.recibido + vals.recibido,
        comision: acc.comision + vals.comision,
        propina: acc.propina + vals.propina
      }
    }, { monto: 0, recibido: 0, comision: 0, propina: 0 })

    return (
      <div className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
        <div className='flex items-start justify-between gap-2'>
          <div className='flex items-start gap-2'>
            <ProviderBadge source={dayTransactions[0]?.source || (activeTab === TRANSBANK ? 'transbank_cartola' : activeTab === GETNET ? 'getnet_ventas' : 'mercadopago_pos')} />
            <div>
              <Text className='text-xs font-bold'>{formatFechaAgrupada(date)}</Text>
              <Text className='text-[11px] text-gray-500'>
                {dayTransactions.length} transacciones
              </Text>
            </div>
          </div>
          <button
            type='button'
            className='flex items-center justify-center w-8 h-8 rounded-full bg-gray-100'
            onClick={() => toggleDay(date)}
            aria-label={isExpanded ? 'Ocultar detalle' : 'Ver detalle'}
          >
            <KeyboardArrowDownIcon
              className={clsx('transition-transform', { 'rotate-180': isExpanded })}
            />
          </button>
        </div>
        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          {getAmountBlock('Monto total', dayTotals.monto)}
          {getAmountBlock('Transacción recibida', dayTotals.recibido, true)}
          {getAmountBlock('Comisión', dayTotals.comision)}
          {getAmountBlock('Propina', dayTotals.propina, true)}
        </div>
      </div>
    )
  }

  const renderTransactionCard = (row, rowId, isGroupedDetail = false) => {
    const statusInfo = getStatusInfo(row)
    const { monto, comision, propina, recibido } = getRowValues(row)
    const isExpanded = expandedTransactions.has(rowId)
    const hasVentas = row.rawData?.ventas?.length > 0

    return (
      <div className={clsx(
        'rounded-2xl border border-gray-100 bg-white shadow-sm p-3',
        isGroupedDetail && 'bg-gray-100'
      )}>
        <div className='flex items-start justify-between gap-2'>
          <div className='flex items-start gap-2'>
            <ProviderBadge source={row.source || (activeTab === TRANSBANK ? 'transbank_cartola' : activeTab === GETNET ? 'getnet_ventas' : 'mercadopago_pos')} />
            <div>
              <Text className='text-xs font-bold'>
                {formatFecha(row.fecha, row.source)}
              </Text>
              <Text className='text-[11px] text-gray-500'>
                {getDescripcion(row)}
              </Text>
            </div>
          </div>
          <div className={statusBadgeClass(statusInfo.isLiberado, statusInfo.isRefunded)}>
            {statusInfo.icon}
            {statusInfo.label}
          </div>
        </div>

        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          <div>
            <Text className='text-[10px] text-gray-400'>POS ID</Text>
            <Text className='text-xs font-semibold'>{getPosId(row)}</Text>
          </div>
          <div className='text-right'>
            <Text className='text-[10px] text-gray-400'>Local</Text>
            <Text className='text-xs font-semibold'>{getLocal(row)}</Text>
          </div>
        </div>

        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          {getAmountBlock('Monto total', monto)}
          {getAmountBlock('Transacción recibida', recibido, true)}
          {getAmountBlock('Comisión', comision)}
          {getAmountBlock('Propina', propina, true)}
        </div>

        {activeTab === GETNET && hasVentas && (
          <button
            type='button'
            onClick={() => toggleTransaction(rowId)}
            className='mt-2 flex items-center gap-1 text-xs font-semibold text-blue-600 hover:text-blue-800'
          >
            {isExpanded ? 'Ocultar ventas' : 'Ver ventas'}
            <KeyboardArrowDownIcon
              style={{ fontSize: 16 }}
              className={clsx('transition-transform', { 'rotate-180': isExpanded })}
            />
          </button>
        )}

        {isExpanded && hasVentas && (
          <div className='mt-2 rounded-lg border border-gray-200 bg-white p-2'>
            <div className='space-y-2'>
              {row.rawData.ventas.map((venta, idx) => (
                <div key={idx} className='flex items-start justify-between text-xs text-gray-600 border-b border-gray-100 pb-2 last:border-0 last:pb-0'>
                  <div>
                    <Text className='text-[11px] font-semibold text-gray-700'>
                      {venta.payload?.fecha_venta || (venta.fecha ? new Date(venta.fecha).toLocaleDateString('es-CL') : 'N/A')}
                    </Text>
                    <Text className='text-[11px] text-gray-500'>
                      {venta.tipoTransaccion || venta.tipo || 'Venta'}
                    </Text>
                    <Text className='text-[11px] text-gray-500'>
                      {venta.payload?.marca} {venta.payload?.tipo}
                      {venta.payload?.cuotas > 1 && ` · ${venta.payload.cuotas} cuotas`}
                    </Text>
                  </div>
                  <Text className='text-xs font-semibold text-gray-800'>
                    {formatCurrency(Number(venta.monto || venta.amount || 0))}
                  </Text>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  if (isMobile) {
    return (
      <div className='space-y-3 font-sans'>
        {activeTab === MERCADOPAGO && summaryData && summaryData.length > 0 ? (
          summaryData.map((daySummary) => {
            const isExpanded = expandedDays[daySummary.fecha]
            const detailRows = Array.isArray(fetchedDetails[daySummary.fecha])
              ? fetchedDetails[daySummary.fecha]
              : []
            return (
              <div key={daySummary.fecha} className='space-y-2'>
                {renderSummaryCard(daySummary)}
                {isExpanded && (
                  <>
                    {loadingDetails[daySummary.fecha] ? (
                      <div className='flex flex-col justify-center items-center py-4'>
                        <Lottie animationData={LoaderAdm} loop style={{ width: 110, height: 110 }} />
                        <Text className='mt-2 text-xs text-center text-gray-500 font-medium'>
                          Obteniendo Pagos digitales. Esto podría tomar unos segundos
                        </Text>
                      </div>
                    ) : (
                      <>
                        {detailRows.map((row, i) => (
                          <div key={`${daySummary.fecha}-${i}`}>
                            {renderTransactionCard(row, `${daySummary.fecha}-${i}`)}
                          </div>
                        ))}
                        {detailRows.length === 0 && (
                          <div className='rounded-xl border border-gray-100 bg-gray-50 px-3 py-2 text-center text-xs text-gray-400'>
                            No se encontraron detalles
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            )
          })
        ) : (
          Object.entries(groupedRows || {}).map(([date, dayTransactions]) => {
            const isExpanded = expandedDetailRows.has(date)
            return (
              <div key={date} className='space-y-2'>
                {renderDayGroupCard(date, dayTransactions)}
                {isExpanded && (
                  <>
                    {loadingDetails[date] ? (
                      <div className='flex flex-col justify-center items-center py-4'>
                        <Lottie animationData={LoaderAdm} loop style={{ width: 110, height: 110 }} />
                      </div>
                    ) : (
                      dayTransactions.map((row, i) => {
                        const rowId = `${date}-${i}`
                        return (
                          <div key={rowId}>
                            {renderTransactionCard(row, rowId, true)}
                          </div>
                        )
                      })
                    )}
                  </>
                )}
              </div>
            )
          })
        )}
      </div>
    )
  }


  return (
    <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            {activeCols.map(({ col, field, width }, i) => (
              <th
                key={i}
                className={clsx(
                  styles.th,
                  width,
                  { 'cursor-pointer hover:text-primary transition-colors': field }
                )}
                onClick={() => field && onSort({ col, field })}
              >
                <div className="flex items-center justify-center gap-1">
                  {activeTab === TRANSBANK && col === 'POS ID' ? 'Codigo Comercio' : col}
                  {order.col === col && (
                    <KeyboardArrowDownIcon
                      style={{ fontSize: 16 }}
                      className={clsx('transition-all', { 'rotate-180': order.direction === 'desc' })}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {activeTab === MERCADOPAGO && summaryData && summaryData.length > 0 ? (
            summaryData.map((daySummary) => {
              const isExpanded = expandedDays[daySummary.fecha]

              return (
                <Fragment key={daySummary.fecha}>
                  <tr
                    className={clsx(styles.tr, 'cursor-pointer hover:bg-blue-50/30')}
                    onClick={() => onToggleDay(daySummary.fecha)}
                  >
                    {activeCols.map(({ col, field }, index) => {
                      if (field === 'fecha') {
                        return (
                          <td key={index} className={styles.td}>
                            <div className="flex items-center justify-center gap-1.5">
                              <Text className={clsx(styles.boldText, 'text-gray-900')}>
                                {formatFechaAgrupada(daySummary.fecha)}
                              </Text>
                            </div>
                          </td>
                        )
                      }

                      if (col === 'Monto Total') {
                        return (
                          <td key={index} className={styles.td}>
                            <Text className={clsx(styles.boldText, 'text-gray-900')}>
                              {formatCurrency(daySummary.montoTotal || 0)}
                            </Text>
                          </td>
                        )
                      }

                      if (col === 'Transacción Recibida') {
                        return (
                          <td key={index} className={styles.td}>
                            <Text className={clsx(styles.boldText, 'text-gray-900')}>
                              {formatCurrency(daySummary.recibidoTotal || 0)}
                            </Text>
                          </td>
                        )
                      }

                      if (col === 'Comisión') {
                        return (
                          <td key={index} className={styles.td}>
                            <Text className={clsx(styles.boldText, 'text-gray-900')}>
                              {formatCurrency(daySummary.comisionTotal || 0)}
                            </Text>
                          </td>
                        )
                      }

                      if (col === 'Propina') {
                        return (
                          <td key={index} className={styles.td}>
                            <Text className={clsx(styles.boldText, 'text-gray-900')}>
                              {formatCurrency(daySummary.propinaTotal || 0)}
                            </Text>
                          </td>
                        )
                      }

                      if (col === 'POS ID') {
                        return (
                          <td key={index} className={styles.td}>
                            <Text className={styles.boldText}>
                              -
                            </Text>
                          </td>
                        )
                      }

                      if (col === 'Local') {
                        return (
                          <td key={index} className={styles.td}>
                            <Text className={styles.boldText}>
                              -
                            </Text>
                          </td>
                        )
                      }

                      if (index === 0) {
                        return (
                          <td key={index} className={styles.td}>
                            <ProviderBadge source={daySummary.source} />
                          </td>
                        )
                      }

                      if (index === activeCols.length - 1) {
                        return (
                          <td key={index} className={styles.td}>
                            <div className="flex flex-col h-full items-center justify-center gap-1">
                              <RowToggle
                                isExpanded={isExpanded}
                                showLabel={false}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  onToggleDay(daySummary.fecha)
                                }}
                              />
                              <button
                                onClick={(e) => {
                                  e.stopPropagation()
                                  onToggleDay(daySummary.fecha)
                                }}
                                className="text-[0.6rem] font-bold text-gray-900 hover:underline uppercase whitespace-nowrap"
                              >
                                {isExpanded ? 'Ocultar' : 'Ver Detalle'}
                              </button>
                            </div>
                          </td>
                        )
                      }

                      if (col === 'Descripción') {
                        return (
                          <td key={index} className={clsx(styles.td, styles.wideCol)}>
                            <Text className={styles.boldText}>
                              Resumen de {daySummary.cantidadTransacciones} Transacciones diarias
                            </Text>
                          </td>
                        )
                      }

                      if (col === 'Local') {
                        return <td key={index} className={styles.td}></td>
                      }

                      return <td key={index} className={styles.td}></td>
                    })}
                  </tr>
                  {isExpanded && (
                    <Fragment>
                      {loadingDetails[daySummary.fecha] ? (
                        <tr className="bg-gray-50/50">
                          <td colSpan={activeCols.length} className="py-10">
                            <div className="flex flex-col justify-center items-center">
                              <Lottie animationData={LoaderAdm} loop style={{ width: 110, height: 110 }} />
                              <Text className="mt-2 text-xs text-center text-gray-500 font-medium">
                                Obteniendo Pagos digitales. Esto podría tomar unos segundos
                              </Text>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        (Array.isArray(fetchedDetails[daySummary.fecha]) ? fetchedDetails[daySummary.fecha] : []).map((row, i) => {
                          const statusInfo = getStatusInfo(row)
                          const { monto, comision, propina, recibido } = getRowValues(row)

                          return (
                            <tr className={clsx(styles.tr, 'bg-gray-50')} key={`${daySummary.fecha}-${i}`}>
                              {activeCols.map(({ field }, colIdx) => {
                                if (field === 'source') return (
                                  <td key={colIdx} className={styles.td}>
                                    <ProviderBadge source={row.source || 'mercadopago_pos'} />
                                  </td>
                                )
                                if (field === 'fecha') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={styles.boldText}>{formatFecha(row.fecha, row.source)}</Text>
                                  </td>
                                )
                                if (field === 'descripcion') return (
                                  <td key={colIdx} className={clsx(styles.td, styles.wideCol)}>
                                    <Text className={styles.boldText}>{getDescripcion(row)}</Text>
                                  </td>
                                )
                                if (field === 'pos_id') return (
                                  <td key={colIdx} className={clsx(styles.td, styles.wideCol)}>
                                    <Text className={clsx(styles.boldText, 'tracking-wider')}>{getPosId(row)}</Text>
                                  </td>
                                )
                                if (field === 'local') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={styles.boldText}>{getLocal(row)}</Text>
                                  </td>
                                )
                                if (field === 'tarjeta') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={styles.boldText}>{getCard(row)}</Text>
                                  </td>
                                )
                                if (field === 'email') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={clsx(styles.boldText, 'break-all')}>{getEmail(row)}</Text>
                                  </td>
                                )
                                if (field === 'ref_externa') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={styles.boldText}>{getRefExterna(row)}</Text>
                                  </td>
                                )
                                if (field === 'preapproval_id') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={clsx(styles.boldText, 'break-all')}>{getPreapprovalId(row)}</Text>
                                  </td>
                                )
                                if (field === 'nombre') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={styles.boldText}>{getCardholderName(row)}</Text>
                                  </td>
                                )
                                if (field === 'tipo_pago_recurrente') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={styles.boldText}>{getTipoPagoRecurrente(row)}</Text>
                                  </td>
                                )
                                if (field === 'num_cuota') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={styles.boldText}>{getNumCuota(row)}</Text>
                                  </td>
                                )
                                if (field === 'monto') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={clsx(styles.boldText, monto > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>{formatCurrency(monto || 0)}</Text>
                                  </td>
                                )
                                if (field === 'recibido') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={clsx(styles.boldText, recibido > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>{formatCurrency(recibido || 0)}</Text>
                                  </td>
                                )
                                if (field === 'comision') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={clsx(styles.boldText, comision > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>{formatCurrency(comision || 0)}</Text>
                                  </td>
                                )
                                if (field === 'propina') return (
                                  <td key={colIdx} className={styles.td}>
                                    <Text className={clsx(styles.boldText, propina > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>{formatCurrency(propina || 0)}</Text>
                                  </td>
                                )
                                if (field === 'status') return (
                                  <td key={colIdx} className={styles.td}>
                                    <div className={statusBadgeClass(statusInfo.isLiberado, statusInfo.isRefunded)}>
                                      {statusInfo.icon}
                                      <Text>{statusInfo.label}</Text>
                                    </div>
                                  </td>
                                )
                                return <td key={colIdx} className={styles.td}>-</td>
                              })}
                            </tr>
                          )
                        })
                      )}

                      {(!loadingDetails[daySummary.fecha] && (!fetchedDetails[daySummary.fecha] || fetchedDetails[daySummary.fecha].length === 0)) && (
                        <tr>
                          <td colSpan={activeCols.length} className="bg-blue-50/20 p-4 text-center text-gray-400 text-xs">
                            No se encontraron detalles
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  )}
                </Fragment>
              )
            })
          ) : (
            Object.entries(groupedRows).map(([date, dayTransactions]) => {
              const isExpanded = expandedDetailRows.has(date)

              const dayTotals = dayTransactions.reduce((acc, row) => {
                const vals = getRowValues(row)
                return {
                  monto: acc.monto + vals.monto,
                  recibido: acc.recibido + vals.recibido,
                  comision: acc.comision + vals.comision,
                  propina: acc.propina + vals.propina
                }
              }, { monto: 0, recibido: 0, comision: 0, propina: 0 })

              return (
                <Fragment key={date}>
                  <>
                    <tr
                      className={clsx(styles.tr, 'cursor-pointer hover:bg-blue-50/30')}
                      onClick={() => toggleDay(date)}
                    >
                      {activeCols.map(({ col, field }, index) => {
                        if (index === 0) {
                          return (
                            <td key={index} className={styles.td}>
                              <div className="flex items-center justify-center">
                                <ProviderBadge source={dayTransactions[0]?.source || (activeTab === TRANSBANK ? 'transbank_cartola' : activeTab === GETNET ? 'getnet_ventas' : 'mercadopago_pos')} />
                              </div>
                            </td>
                          )
                        }

                        if (field === 'fecha') {
                          return (
                            <td key={index} className={styles.td}>
                              <div className="flex items-center justify-center gap-1.5">
                                <Text className={styles.boldText}>
                                  {formatFechaAgrupada(date)}
                                </Text>
                              </div>
                            </td>
                          )
                        }

                        if (col === 'Descripción') {
                          return (
                            <td key={index} className={styles.td}>
                              <Text className={clsx(styles.boldText, 'text-gray-600')}>
                                Resumen de {dayTransactions.length} Transacciones diarias
                              </Text>
                            </td>
                          )
                        }

                        if (col === 'POS ID') {
                          return (
                            <td key={index} className={styles.td}>
                              <Text className={styles.text}>
                                {getPosId(dayTransactions[0])}
                              </Text>
                            </td>
                          )
                        }

                        if (col === 'Local') {
                          return (
                            <td key={index} className={styles.td}>
                              <Text className={styles.text}>
                                {getLocal(dayTransactions[0])}
                              </Text>
                            </td>
                          )
                        }

                        if (col === 'Monto Total') {
                          return (
                            <td key={index} className={styles.td}>
                              <Text className={clsx(styles.boldText, dayTotals.monto > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>
                                {formatCurrency(dayTotals.monto || 0)}
                              </Text>
                            </td>
                          )
                        }

                        if (col === 'Transacción Recibida') {
                          return (
                            <td key={index} className={styles.td}>
                              <Text className={clsx(styles.boldText, dayTotals.recibido > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>
                                {formatCurrency(dayTotals.recibido || 0)}
                              </Text>
                            </td>
                          )
                        }

                        if (col === 'Comisión') {
                          return (
                            <td key={index} className={styles.td}>
                              <Text className={clsx(styles.boldText, dayTotals.comision > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>
                                {formatCurrency(dayTotals.comision || 0)}
                              </Text>
                            </td>
                          )
                        }

                        if (col === 'Propina') {
                          return (
                            <td key={index} className={styles.td}>
                              <Text className={clsx(styles.boldText, dayTotals.propina > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>
                                {formatCurrency(dayTotals.propina || 0)}
                              </Text>
                            </td>
                          )
                        }

                        if (index === activeCols.length - 1) {
                          return (
                            <td key={index} className={styles.td}>
                              <div className="flex flex-col h-full items-center justify-center gap-1">
                                <RowToggle
                                  isExpanded={isExpanded}
                                  showLabel={false}
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    toggleDay(date)
                                  }}
                                />
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    toggleDay(date)
                                  }}
                                  className="text-[0.6rem] font-bold text-gray-900 hover:underline uppercase whitespace-nowrap"
                                >
                                  {isExpanded ? 'Ocultar' : 'Ver Detalle'}
                                </button>
                              </div>
                            </td>
                          )
                        }

                        return <td key={index} className={styles.td}></td>
                      })}
                    </tr>
                    {isExpanded && (
                      <Fragment>
                        {loadingDetails[date] ? (
                          <tr className="bg-gray-50/50">
                            <td colSpan={activeCols.length} className="py-10">
                              <div className="flex flex-col justify-center items-center">
                                <Lottie animationData={LoaderAdm} loop style={{ width: 110, height: 110 }} />
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <>
                            {dayTransactions.map((row, i) => {
                              const statusInfo = getStatusInfo(row)
                              const { monto, comision, propina, recibido } = getRowValues(row)
                              const rowId = `${date}-${i}`
                              const isTransactionExpanded = expandedTransactions.has(rowId)
                              const hasVentas = row.rawData?.ventas?.length > 0

                              return (
                                <Fragment key={rowId}>
                                  <tr
                                    className={clsx(styles.tr, 'bg-gray-50', { 'cursor-pointer hover:bg-gray-100': hasVentas })}
                                    onClick={(e) => {
                                      if (hasVentas) {
                                        e.stopPropagation()
                                        toggleTransaction(rowId)
                                      }
                                    }}
                                  >
                                    {activeCols.map(({ field }, colIdx) => {
                                      const fallbackSource = activeTab === TRANSBANK ? 'transbank_cartola' : activeTab === GETNET ? 'getnet_ventas' : 'mercadopago_pos'
                                      if (field === 'source') return (
                                        <td key={colIdx} className={styles.td}>
                                          <ProviderBadge source={row.source || fallbackSource} />
                                        </td>
                                      )
                                      if (field === 'fecha') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.boldText}>{formatFechaAgrupada(date)}</Text>
                                        </td>
                                      )
                                      if (field === 'descripcion') return (
                                        <td key={colIdx} className={clsx(styles.td, styles.wideCol)}>
                                          <Text className={styles.text}>{getDescripcion(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'pos_id') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.text}>{getPosId(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'local') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.text}>{getLocal(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'tarjeta') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.text}>{getCard(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'email') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={clsx(styles.text, 'break-all')}>{getEmail(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'ref_externa') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.text}>{getRefExterna(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'preapproval_id') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={clsx(styles.text, 'break-all')}>{getPreapprovalId(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'nombre') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.text}>{getCardholderName(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'tipo_pago_recurrente') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.text}>{getTipoPagoRecurrente(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'num_cuota') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={styles.text}>{getNumCuota(row)}</Text>
                                        </td>
                                      )
                                      if (field === 'monto') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={clsx(styles.boldText, monto > 0 ? 'text-gray-900' : 'text-gray-300')}>{formatCurrency(monto || 0)}</Text>
                                        </td>
                                      )
                                      if (field === 'recibido') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={clsx(styles.boldText, recibido > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>{formatCurrency(recibido || 0)}</Text>
                                        </td>
                                      )
                                      if (field === 'comision') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={clsx(styles.boldText, comision > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>{formatCurrency(comision || 0)}</Text>
                                        </td>
                                      )
                                      if (field === 'propina') return (
                                        <td key={colIdx} className={styles.td}>
                                          <Text className={clsx(styles.boldText, propina > 0 ? 'text-gray-900 font-black' : 'text-gray-300')}>{formatCurrency(propina || 0)}</Text>
                                        </td>
                                      )
                                      if (field === 'status') return (
                                        <td key={colIdx} className={styles.td}>
                                          <div className="flex items-center justify-center gap-2">
                                            <div className={statusBadgeClass(statusInfo.isLiberado, statusInfo.isRefunded)}>
                                              {statusInfo.icon}
                                              <Text>{statusInfo.label}</Text>
                                            </div>
                                            {activeTab === GETNET && hasVentas && (
                                              <div
                                                className="cursor-pointer flex items-center gap-1 text-blue-600 hover:text-blue-800 transition-colors"
                                                onClick={(e) => {
                                                  e.stopPropagation()
                                                  toggleTransaction(rowId)
                                                }}
                                              >
                                                <span className="text-[0.65rem] font-bold underline whitespace-nowrap">
                                                  {isTransactionExpanded ? 'Ocultar ventas' : 'Ver ventas'}
                                                </span>
                                                <KeyboardArrowDownIcon
                                                  style={{ fontSize: 16 }}
                                                  className={clsx('transition-transform', { 'rotate-180': isTransactionExpanded })}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </td>
                                      )
                                      return <td key={colIdx} className={styles.td}>-</td>
                                    })}
                                  </tr>
                                  {isTransactionExpanded && hasVentas && (
                                    <tr className="bg-gray-100/50">
                                      <td colSpan={activeCols.length} className="p-4 pl-12">
                                        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                                          <table className="w-full text-[0.7rem] font-sans">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                              <tr>
                                                <th className="py-2 px-3 text-left font-semibold text-gray-600">Fecha Venta</th>
                                                <th className="py-2 px-3 text-left font-semibold text-gray-600">Tipo</th>
                                                <th className="py-2 px-3 text-left font-semibold text-gray-600">Detalle</th>
                                                <th className="py-2 px-3 text-right font-semibold text-gray-600">Monto </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {row.rawData.ventas.map((venta, idx) => (
                                                <tr key={idx} className="border-b border-gray-100 last:border-0 hover:bg-gray-50">
                                                  <td className="py-2 px-3 text-gray-600">
                                                    {venta.payload?.fecha_venta || (venta.fecha ? new Date(venta.fecha).toLocaleDateString('es-CL') : 'N/A')}
                                                  </td>
                                                  <td className="py-2 px-3 text-gray-600">
                                                    {venta.tipoTransaccion || venta.tipo || 'Venta'}
                                                  </td>
                                                  <td className="py-2 px-3 text-gray-600">
                                                    <div className="flex flex-col">
                                                      <span>{venta.payload?.marca} {venta.payload?.tipo}</span>
                                                      {venta.payload?.cuotas > 1 && (
                                                        <span className="text-[0.6rem] text-gray-400">{venta.payload.cuotas} cuotas</span>
                                                      )}
                                                    </div>
                                                  </td>
                                                  <td className="py-2 px-3 text-right font-medium text-gray-800">
                                                    {formatCurrency(Number(venta.monto || venta.amount || 0))}
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                  }
                                </Fragment>
                              )
                            })}
                          </>
                        )}
                      </Fragment>
                    )}
                  </>
                </Fragment>
              )
            })
          )}
        </tbody>
    </table>
  )
}

export default TableTransactions
